export const TOKEN = 'sr-dts-token'
export const DIVISION_USER_ADMIN_LEVEL = 3
export const TOP_BAR_HEIGHT = 64
export const SIDE_NAV_WIDTH = 260
export const NAV_BAR_HEIGHT = 60
export const CONTAINER_LAYOUT_WIDTH = 1200
export const LOCALIZE = 'km'
export const INTENDED_URL = 'intended-url'
export const USER_PERMISSIONS = 'user-permission'